import styled from 'styled-components';
import IconAlert from '@carvana/icons/IconAlert';

export const EditDisclaimerWrapper = styled.div`
  display: flex;
  flex-flow: row;
  padding: 1em;
  margin-bottom: 0.5em;
  align-content: left;
  @media (min-width: ${(props: any) => props.theme.breakpoints.values.sm}px) {
    padding: 0 2em 1em 2em;
  }
`;

export const AlertIcon = styled(IconAlert)`
  color: ${(props: any) => props.theme.carvana.yellow.primary};
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  margin-right: 10px;
`;

export const Disclaimer = styled.div``;

export const DisclaimerText = styled.p`
  margin: 0;
  color: ${(props: any) => props.theme.carvana.gray.dark};
  font-size: 16px;
  font-weight: 400;
  align-self: left;
  line-height: 22px;
`;

export const Link = styled.a`
  color: ${(props: any) => props.theme.carvana.blue.primary};
  text-decoration: none;
  :hover {
    color: ${(props: any) => props.theme.carvana.blue.hover};
  }
`;
